import React from 'react';
import { IconButton, IContextualMenuProps, IContextualMenuItem, Icon, ContextualMenu, IContextualMenuStyles } from '@fluentui/react';
import { useConst } from '@fluentui/react-hooks';
import styled from 'styled-components';
import { useConstCallback } from '@uifabric/react-hooks';

type ButtonMenuContextProps = {
    MenuItems: IContextualMenuItem[],
    IconName: string,
    ClassName?: string,
};
const ContainerStyle = styled.div`
i[data-icon-name="ChevronDown"]{
    display:none;

}
`;
export default ({ MenuItems, IconName, ClassName }: ButtonMenuContextProps) => {
    const linkRef = React.useRef(null);
    const menuProps = useConst<IContextualMenuProps>(() => ({
        shouldFocusOnMount: true,
        items: MenuItems,
    }));
    const [showContextualMenu, setShowContextualMenu] = React.useState(false);
    const onHideContextualMenu = useConstCallback(() => setShowContextualMenu(false));
    return (<ContainerStyle ref={linkRef} onClick={(ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        setShowContextualMenu(!showContextualMenu);
    }}>
        <IconButton className={ClassName} iconProps={{ iconName: IconName }} />
        <ContextualMenu
            items={MenuItems}
            target={linkRef}
            hidden={!showContextualMenu}
            onItemClick={onHideContextualMenu}
            onDismiss={onHideContextualMenu}
            styles={{ container: { minWidth: 200 }, root: { minWidth: 200 } } as IContextualMenuStyles}
        />
    </ContainerStyle>);
};

